var _g, _path, _g2, _path2, _g3, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportBuildingClaimSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 224,
    viewBox: "0 0 230 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5003_40159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.607 4.983a2.83 2.83 0 00-2.78 2.869v148.103a2.829 2.829 0 002.78 2.869h108.106a2.83 2.83 0 002.781-2.869V7.852a2.828 2.828 0 00-2.781-2.87H7.607z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.905 82.395H50.1c-.276 0-.549-.063-.804-.189a2.116 2.116 0 01-.68-.542 2.574 2.574 0 01-.456-.811 2.92 2.92 0 01-.16-.957c0-.329.054-.654.16-.958.105-.303.26-.58.455-.811.195-.232.427-.416.681-.542.255-.125.528-.19.804-.19h49.805c.556.001 1.089.265 1.482.734.392.468.613 1.104.613 1.766 0 .663-.221 1.299-.613 1.767-.393.47-.926.733-1.482.733zm0-45H50.1c-.276 0-.549-.064-.804-.189a2.116 2.116 0 01-.68-.542 2.574 2.574 0 01-.456-.811 2.92 2.92 0 01-.16-.958c0-.328.054-.653.16-.957.105-.303.26-.58.455-.811.195-.232.427-.416.681-.542.255-.126.528-.19.804-.19h49.805c.556.001 1.089.265 1.482.734.392.468.613 1.104.613 1.767 0 .662-.221 1.297-.613 1.766-.393.47-.926.733-1.482.733zm8.986 54h-58.78a1.82 1.82 0 01-.807-.189 2.124 2.124 0 01-.685-.542 2.572 2.572 0 01-.458-.811 2.906 2.906 0 01-.161-.957c0-.329.055-.654.16-.958.107-.303.263-.58.459-.811.196-.232.428-.416.685-.542.256-.125.53-.19.807-.19h58.78c.559 0 1.096.264 1.491.733.396.469.618 1.105.618 1.767 0 .663-.222 1.3-.618 1.768-.395.47-.932.733-1.491.733zm0-45h-58.78c-.277 0-.551-.064-.807-.189a2.124 2.124 0 01-.685-.542 2.572 2.572 0 01-.458-.811 2.906 2.906 0 01-.161-.958c0-.328.055-.653.16-.957.107-.303.263-.58.459-.811.196-.232.428-.416.685-.542.256-.126.53-.19.807-.19h58.78c.559 0 1.096.264 1.491.733.396.469.618 1.105.618 1.767 0 .663-.222 1.3-.618 1.768-.395.47-.932.733-1.491.733zm-8.988 77.001H50.1a1.57 1.57 0 01-.804-.228 2.218 2.218 0 01-.68-.65 3.299 3.299 0 01-.456-.974 4.14 4.14 0 01-.16-1.149c0-.394.054-.784.16-1.148.105-.365.26-.695.455-.974s.427-.5.681-.65c.255-.151.528-.228.804-.227h49.803c.556 0 1.089.316 1.483.878.393.563.614 1.326.614 2.121 0 .796-.221 1.559-.614 2.122-.394.562-.927.879-1.483.879zm8.986 9H50.111c-.277 0-.551-.065-.807-.19a2.122 2.122 0 01-.686-.542 2.573 2.573 0 01-.457-.811 2.91 2.91 0 010-1.915c.106-.303.261-.579.457-.811.197-.232.43-.417.685-.542.257-.125.531-.19.808-.189h58.778a1.82 1.82 0 01.807.189c.257.125.489.31.685.542.197.232.352.508.458.811a2.915 2.915 0 010 1.915 2.554 2.554 0 01-.458.811 2.111 2.111 0 01-.685.542c-.256.125-.53.19-.807.19zM35.94 95.745H13.293A1.293 1.293 0 0112 94.452v-20.16A1.294 1.294 0 0113.292 73h22.649a1.294 1.294 0 011.292 1.292v20.16a1.294 1.294 0 01-1.292 1.293zm0-45H13.293A1.293 1.293 0 0112 49.452v-20.16A1.294 1.294 0 0113.292 28h22.649a1.294 1.294 0 011.292 1.292v20.16a1.294 1.294 0 01-1.292 1.293zm0 85.763H13.293A1.293 1.293 0 0112 135.216v-20.161a1.294 1.294 0 011.292-1.292h22.649a1.298 1.298 0 011.292 1.292v20.161a1.294 1.294 0 01-1.292 1.292z",
    fill: "#E6E6E6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5003_40159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.937 40.173a2.829 2.829 0 00-2.78 2.869v148.103a2.829 2.829 0 002.78 2.869h108.107a2.83 2.83 0 002.78-2.869V43.042a2.828 2.828 0 00-2.78-2.87H47.937z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.905 123H91.1c-.276 0-.549-.064-.804-.19a2.108 2.108 0 01-.68-.541 2.569 2.569 0 01-.456-.812 2.914 2.914 0 01-.16-.957c0-.329.054-.654.16-.957.105-.304.26-.58.455-.812.195-.232.427-.416.681-.542.255-.125.528-.189.804-.189h49.805c.556.001 1.089.264 1.482.733.392.469.613 1.104.613 1.767 0 .663-.221 1.298-.613 1.767-.393.469-.926.732-1.482.733zm8.986 9h-58.78c-.277 0-.551-.064-.807-.19a2.116 2.116 0 01-.685-.541 2.567 2.567 0 01-.458-.812A2.9 2.9 0 0189 129.5a2.9 2.9 0 01.16-.957 2.59 2.59 0 01.459-.812c.196-.232.428-.416.685-.542.256-.125.53-.189.807-.189h58.78c.559 0 1.096.263 1.491.732.396.469.618 1.105.618 1.768s-.222 1.299-.618 1.768c-.395.469-.932.732-1.491.732zm-8.988 32H91.1c-.276 0-.549-.077-.804-.227a2.242 2.242 0 01-.68-.65 3.31 3.31 0 01-.456-.974A4.146 4.146 0 0189 161c0-.394.054-.785.16-1.149a3.31 3.31 0 01.455-.974 2.25 2.25 0 01.681-.65c.255-.15.528-.227.804-.227h49.803c.556 0 1.089.316 1.483.879.393.562.614 1.325.614 2.121s-.221 1.559-.614 2.121c-.394.563-.927.879-1.483.879zm8.986 9H91.111c-.277 0-.551-.064-.808-.19a2.118 2.118 0 01-.684-.541 2.567 2.567 0 01-.458-.812A2.9 2.9 0 0189 170.5a2.9 2.9 0 01.16-.957 2.57 2.57 0 01.459-.812c.196-.232.428-.416.684-.541.257-.126.531-.19.808-.19h58.778c.277 0 .551.064.807.19.257.125.489.309.685.541.197.232.352.508.458.812a2.904 2.904 0 010 1.914c-.106.304-.261.58-.458.812a2.108 2.108 0 01-.685.541c-.256.126-.53.19-.807.19zM76.94 136.349H54.293A1.292 1.292 0 0153 135.057v-20.16a1.296 1.296 0 011.292-1.293h22.649a1.298 1.298 0 011.292 1.293v20.16a1.292 1.292 0 01-1.292 1.292zm0 40.763H54.293A1.293 1.293 0 0153 175.82v-20.16a1.294 1.294 0 011.292-1.293h22.649a1.298 1.298 0 011.292 1.293v20.16a1.294 1.294 0 01-1.292 1.292z",
    fill: "#E6E6E6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5003_40159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126 79.5H79v19h47v-19z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 80.499l5.137-20h41.027l3.836 20H77z",
    fill: "#88D6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 62.498H90v11h25v-11z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.865 52.5l-3.867 12h29l-2.285-12H91.865z",
    fill: "#88D6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.726 83.945h-7.312v13.55h7.312v-13.55zm11.482.769h-3.565v3.515h3.565v-3.515zm4.773 0h-3.565v3.515h3.565v-3.515zm-4.773 4.792h-3.565v3.644h3.565v-3.644zm4.773 0h-3.565v3.644h3.565v-3.644zm-11.757-24.201h-2.79v2.75h2.79v-2.75zm3.734 0h-2.79v2.75h2.79v-2.75zm-3.734 3.751h-2.79v2.851h2.79v-2.85zm3.734 0h-2.79v2.851h2.79v-2.85zM96.83 65.305h-2.79v2.75h2.79v-2.75zm3.734 0h-2.79v2.75h2.79v-2.75zm-3.734 3.751h-2.79v2.851h2.79v-2.85zm3.734 0h-2.79v2.851h2.79v-2.85z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.804 85.318h-1.757v1.732h1.757v-1.732zm2.353 0H99.4v1.732h1.757v-1.732zm-2.353 2.364h-1.757v1.795h1.757v-1.795zm2.353 0H99.4v1.795h1.757v-1.795zm.604 4.51a.498.498 0 00.483-.512.498.498 0 00-.483-.511.498.498 0 00-.484.511c0 .283.217.512.484.512z",
    fill: "#F5F4F0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.759 154.486l-39.833 39.513a2.648 2.648 0 01-3.745-.015l-18.954-19.107a2.648 2.648 0 01.015-3.745l1.881-1.865a2.648 2.648 0 013.745.015l15.223 15.346 36.072-35.783a2.648 2.648 0 013.745.015l1.866 1.881a2.648 2.648 0 01-.015 3.745z",
    fill: "#49BC74"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5003_40159",
    x: 2.826,
    y: 3.983,
    width: 117.668,
    height: 157.841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5003_40159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5003_40159",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5003_40159",
    x: 43.156,
    y: 39.173,
    width: 117.668,
    height: 157.841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5003_40159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5003_40159",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5003_40159",
    x: 76,
    y: 50,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5003_40159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5003_40159",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportBuildingClaimSuccess);
export default __webpack_public_path__ + "static/media/reportBuildingClaimSuccess.7f9e3038d98d8f32b7c69fcdf9dcb726.svg";
export { ForwardRef as ReactComponent };